import {addDynamicDialog} from 'crazyEditor/redux/modules/panel/panel';
import {getPriceText} from 'MyAccount/AccountPage/PlanAndBilling/Consts';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import InlineButton from 'shared/components/InlineButton';
import styles from '../AccountPageStyles';
import * as routes from 'App/routeConstants';
import InlineNotification, {
  LEVEL_NOTICE,
  LEVEL_ERROR,
} from 'crazyEditor/components/EditorUI/BaseUI/InlineMessages/InlineNotification';
import _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import ReadOnlyTextField from 'crazyEditor/components/EditorUI/BaseUI/ReadOnlyTextField/ReadOnlyTextField';
import ChangePlanDialog from './ChangePlanDialog';
import EditPaidFeaturesDialog from 'MyAccount/AccountPage/PlanAndBilling/EditPaidFeaturesDialog';
import {
  CHANGE_TYPE_BILLING_PERIOD,
  CHANGE_PLAN_DIALOG_NAME,
  BILLING_PERIOD,
  PAYMENT_SUCCESS_TYPE,
  BACKGROUND_REMOVAL,
  FOOTER_REMOVAL,
  INVENTORY_SYNC,
} from './Consts';
import {minusCircle, warning, info, checkCircle} from 'shared/icons';
import {retryPayment} from 'MyAccount/ViewDesigns/helpers/preferencesHelper';
import {updateUserData} from 'MyAccount/ViewDesigns/redux/modules/user';
import * as Colors from 'material-ui/styles/colors';
import {contactSupportWithMessage} from 'shared/helpers/analyticsHelper';
import InfoDialog from 'shared/components/Dialogs/InfoDialog/InfoDialog';
import Toggle from 'material-ui/Toggle';
import {PlanAndBilling as PlanAndBillingData} from '../AccountPageSectionsData';
import {BillingHistory as BillingHistoryData} from '../AccountPageSectionsData';
import {setWindowBusy} from 'MyAccount/ViewDesigns/redux/modules/general';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import {store} from '../../../App/store';

const CONTENT_MAX_WIDTH = 680;
const SAME_LINE_BUTTON_SPACING = 240;

@connectWithRouter(
  state => ({
    plans: _.keyBy(state.user.plans, 'id'),
    userPlanId: state.user.userPlan.id,
    billingPeriod: state.user.billingPeriod,
    billingPeriodString: state.user.billingPeriodString,
    switchToAnnualSave: state.user.switchToAnnualSave,
    eBayAccountsCount: state.accountPage.accounts ? _.size(state.accountPage.accounts) : 0,
    eBayAccountsLimit: state.user.userPlan.eBayAccountsLimit,
    activeListingsLimit: state.user.userPlan.activeListingsLimit,
    customPlan: state.user.userPlan.custom,
    activeListingsCount: state.user.activeListingsCount,
    paymentError: state.user.paymentError,
    query: state.routing.location.query,
    pathname: state.routing.location.pathname,
    paymentSuccessType: state.routing.location.query.paymentSuccessType,
    renewBillingAgreementStatus: state.routing.location.query.renewBillingAgreementStatus,
    errorMessage: state.routing.location.query.errorMessage,
    nextScheduledPayment: state.user.nextScheduledPayment
      ? new Date(1000 * parseInt(state.user.nextScheduledPayment, 10)).toLocaleDateString()
      : '',
    userCredit: state.user.referrals.userCredit,
    paidFeaturesData: state.user.paidFeatures,
    inventorySync: state.user.inventorySync,
    footerRemoval: state.user.isWhiteLabel,
    backgroundRemoval: state.user.backgroundRemoval,
    paypalEmail: state.user.paypalEmail,
    lastSuccessfulPayment: new Date(1000 * parseInt(state.user.lastSuccessfulPayment, 10)).toLocaleDateString(),
    price: state.user.price,
  }),
  {updateUserData, setWindowBusy}
)
export class PlanAndBilling extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    const {userCredit} = this.props;

    this.state = {
      creditStatusMessage: this.getCreditStatusMessage(userCredit),
      statusMessage: null,
      showPaymentDetails: false,
      showSuccessfulRenewBillingAgreementMessage: false,
    };
  }

  componentWillMount() {
    if (!window.Appcues) {
      console.warn("Can't find Appcues, Cancel button is hidden");
    }
    const {renewBillingAgreementStatus, errorMessage} = this.props;
    if (renewBillingAgreementStatus) {
      if (renewBillingAgreementStatus === 'success') {
        this.setState({showSuccessfulRenewBillingAgreementMessage: true});
      } else {
        if (renewBillingAgreementStatus === 'failure' && errorMessage) {
          const contactSupport = contactSupportWithMessage.bind(
            null,
            `I got this error while trying to update my Paypal details: ${errorMessage}`
          );
          InfoDialog.info({
            title: 'Paypal details update failed',
            message: (
              <div>
                <div style={{marginBottom: 20, marginTop: 35}}>Paypal details update failed due to:</div>
                <InlineNotification style={{width: 820}} level={LEVEL_ERROR} animate={false}>
                  {errorMessage}
                </InlineNotification>
                <div style={{marginTop: 20}}>
                  If you don’t know how to fix this you may{' '}
                  <InlineButton onClick={contactSupport}>ask for help</InlineButton> from Crazylister’s team. We are
                  always happy to help.
                </div>
              </div>
            ),
            action: this.handleUpdatePaypalDetails,
            buttonLabel: 'Try again',
            level: 'error',
            cancelButtonLabel: 'Cancel',
          });
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const {userCredit} = this.props;
    if (nextProps.userCredit !== userCredit) {
      this.setState({
        creditStatusMessage: this.getCreditStatusMessage(nextProps.userCredit),
      });
    }
  }

  getCreditStatusMessage(userCredit) {
    return (
      <span>
        You currently have US ${userCredit} on your Crazylister credit.
        <br />
        This amount will be subtracted from your next payment!
      </span>
    );
  }

  handleRetryPayment = () => {
    const {updateUserData} = this.props;
    const {pathname, query} = this.props;
    const showErrorDialog = (error = 'Unknown Error') => {
      const contactSupport = contactSupportWithMessage(
        `I got this error message while trying to resolve a payment issue: ${error}`
      );
      InfoDialog.info({
        level: 'error',
        message: (
          <div>
            <div style={{fontWeight: 300, fontSize: 24, marginBottom: 5}}>
              We ran into some trouble processing your payment.
            </div>
            <div style={{marginBottom: 35}}>This is the error we get:</div>
            <InlineNotification style={{height: 60, width: 820, marginBottom: 25}} level="error" iconPath={warning}>
              {error}
            </InlineNotification>
            We encourage you to contact PayPal for more information.
            <br />
            Let’s get you back on track, once ready:{' '}
            <InlineButton onClick={this.handleRetryPayment}>retry payment.</InlineButton>
            <br />
            Still have questions? <InlineButton onClick={contactSupport}>contact support.</InlineButton>
          </div>
        ),
        title: 'Payment Failed',
        buttonLabel: 'retry payment',
        cancelButtonLabel: 'contact support',
        action: this.handleRetryPayment,
        secondaryAction: () => contactSupport,
      });
    };
    retryPayment()
      .then(response => {
        if (response.success) {
          updateUserData(response.user);
          this.context.router.push({pathname, query: {...query, paymentSuccessType: PAYMENT_SUCCESS_TYPE.RETRY}});
        } else {
          showErrorDialog(response.message);
        }
      })
      .fail(response => {
        showErrorDialog(response.responseJSON.message);
      });
  };

  handleToggle(paidFeatureName) {
    store.dispatch(addDynamicDialog(EditPaidFeaturesDialog, {paidFeatureName}));
  }

  handleUpdatePaypalDetails = () => {
    const {setWindowBusy} = this.props;
    setWindowBusy(true);
    window.location = '/application/user/test-paypal-one?renewBillingAgreement=true';
  };

  renderAdditionalFeatures() {
    const {paidFeaturesData, inventorySync, footerRemoval, backgroundRemoval, billingPeriod} = this.props;

    const inventorySyncPriceText = getPriceText(INVENTORY_SYNC, paidFeaturesData, billingPeriod);
    const footerRemovalPriceText = getPriceText(FOOTER_REMOVAL, paidFeaturesData, billingPeriod);
    const backgroundRemovalPriceText = getPriceText(BACKGROUND_REMOVAL, paidFeaturesData, billingPeriod);
    const getToggle = (props, text) => (
      <div style={{display: 'flex', flexDirection: 'row', width: '80%'}}>
        <div style={{width: '100%'}}>
          <Toggle labelPosition="right" labelStyle={{textIndent: 10}} {...props} />
        </div>
        <div style={{width: '100%', paddingTop: 2, color: Colors.grey400}}>{text}</div>
      </div>
    );
    return (
      <Paper
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          paddingTop: 30,
          paddingBottom: 30,
          paddingLeft: 20,
          maxWidth: CONTENT_MAX_WIDTH,
          marginBottom: 30,
        }}
      >
        <div style={{...styles.h2b, marginBottom: 30}}>Additional Features</div>
        {getToggle(
          {
            id: `cla-btn-${inventorySync ? 'disable' : 'enable'}-inventory-sync`,
            label: INVENTORY_SYNC,
            toggled: inventorySync,
            onToggle: () => this.handleToggle(INVENTORY_SYNC),
          },
          inventorySyncPriceText + ' (early bird price)'
        )}
        {getToggle(
          {
            id: `cla-btn-${footerRemoval ? 'disable' : 'enable'}-footer-removal`,
            label: FOOTER_REMOVAL,
            toggled: footerRemoval,
            onToggle: () => this.handleToggle(FOOTER_REMOVAL),
          },
          footerRemovalPriceText
        )}
        {getToggle(
          {
            id: `cla-toggle-${backgroundRemoval ? 'disable' : 'enable'}-background-removal`,
            label: BACKGROUND_REMOVAL,
            toggled: backgroundRemoval,
            onToggle: () => this.handleToggle(BACKGROUND_REMOVAL),
          },
          backgroundRemovalPriceText
        )}
      </Paper>
    );
  }

  renderPaymentDetails() {
    const {lastSuccessfulPayment, price, paypalEmail, nextScheduledPayment, userCredit} = this.props;
    const {showPaymentDetails} = this.state;

    const showPaymentDetailsText = showPaymentDetails ? 'Hide Payment Details' : 'Show Payment Details';

    return [
      <InlineButton
        id={`cla-btn-${showPaymentDetails ? 'hide' : 'show'}-payment-details`}
        style={{marginBottom: 30, zIndex: 2}}
        onClick={() =>
          this.setState({
            showPaymentDetails: !showPaymentDetails,
          })
        }
        key="show_payment_button"
      >
        {showPaymentDetailsText}
      </InlineButton>,
      <Paper
        key="payment_details_wrapper"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          paddingTop: 30,
          paddingBottom: 30,
          paddingLeft: 20,
          maxWidth: CONTENT_MAX_WIDTH,
          marginBottom: 30,
          transition: 'all ' + 250 + 'ms ease-in-out',
          opacity: showPaymentDetails ? 1 : 0,
          transform: showPaymentDetails ? 'translateY(0px)' : 'translateY(-25px)',
          zIndex: 1,
        }}
      >
        <div style={{...styles.h2b, marginBottom: 30}}>Payment Details</div>
        {paypalEmail && (
          <div>
            <span style={{width: SAME_LINE_BUTTON_SPACING, display: 'inline-block'}}>
              <ReadOnlyTextField
                id="cla-paypal-email"
                floatingLabelText="Paypal Email"
                value={paypalEmail}
                style={{marginRight: 20}}
              />
            </span>
            <InlineButton id="cla-btn-update-paypal-details" onClick={this.handleUpdatePaypalDetails}>
              Update Paypal details
            </InlineButton>
          </div>
        )}
        <div>
          <span style={{width: SAME_LINE_BUTTON_SPACING, display: 'inline-block'}}>
            <ReadOnlyTextField
              id="cla-last-payment-date"
              floatingLabelText="Last Payment Date"
              value={lastSuccessfulPayment}
              style={{marginRight: 20}}
            />
          </span>
          <InlineButton
            id="cla-btn-view-invoices"
            onClick={() => this.context.router.push(`${routes.MyAccount.AccountPageBase}/${BillingHistoryData.label}`)}
            style={{verticalAlign: 'bottom', top: -14}}
          >
            View Invoices
          </InlineButton>
        </div>
        {nextScheduledPayment && (
          <div>
            <span style={{width: SAME_LINE_BUTTON_SPACING, display: 'inline-block'}}>
              <ReadOnlyTextField
                id="cla-next-payment-date"
                floatingLabelText="Next Payment Date"
                value={nextScheduledPayment}
                style={{marginRight: 20}}
              />
            </span>
            {window.Appcues ? (
              <InlineButton
                onClick={() => window.Appcues.show('-LGdTUcMfF4Ow6EizXEz')}
                style={{verticalAlign: 'bottom', top: -14, color: Colors.red700}}
              >
                Cancel Account
              </InlineButton>
            ) : (
              undefined
            )}
          </div>
        )}
        <ReadOnlyTextField
          id="cla-next-payment-amount"
          floatingLabelText="Next Payment Amount"
          value={'US $' + (price - userCredit > 0 ? price - userCredit : 0)}
          style={{marginRight: 20}}
        />
      </Paper>,
    ];
  }

  renderNotifications() {
    const {paymentError, nextScheduledPayment, userCredit, paypalEmail, paymentSuccessType} = this.props;
    const {creditStatusMessage, showSuccessfulRenewBillingAgreementMessage} = this.state;

    let successMessage;
    let successId;
    switch (paymentSuccessType) {
      case PAYMENT_SUCCESS_TYPE.PLAN:
        successMessage = 'Your plan was updated successfully.';
        successId = 'plan-update-success';
        break;
      case PAYMENT_SUCCESS_TYPE.RETRY:
        successMessage = 'Your payment processed successfully.';
        successId = 'payment-process-success';
        break;
      case PAYMENT_SUCCESS_TYPE.BILLING_PERIOD:
        successMessage = 'Your billing cycle was updated successfully.';
        successId = 'cycle-update-success';
        break;
      default:
        successMessage = false;
        break;
    }

    return [
      Boolean(userCredit && creditStatusMessage) && (
        <InlineNotification
          id="cla-notification-credit-status"
          style={{maxWidth: CONTENT_MAX_WIDTH, marginBottom: 20, height: 80}}
          onRequestClose={() => {
            this.setState({creditStatusMessage: null});
          }}
          level={LEVEL_NOTICE}
          iconPath={info}
        >
          {creditStatusMessage}
        </InlineNotification>
      ),
      !!paymentError && (
        <InlineNotification
          id="cla-inline-notification-payment-error"
          level={LEVEL_ERROR}
          iconPath={minusCircle}
          style={{maxWidth: CONTENT_MAX_WIDTH, marginBottom: 20}}
          animate={false}
        >
          We ran into some trouble processing your payment.
          <br />
          We failed to charge your PayPal on <strong>{nextScheduledPayment}</strong>.<br />
          We encourage you to contact PayPal for more information.
          <br />
          Let’s get you back on track. When ready{' '}
          <InlineButton key="retryPayment" style={{color: Colors.red900}} onClick={this.handleRetryPayment}>
            Retry Payment.
          </InlineButton>
          <br />
          Complete your payment to make sure your account keeps functioning as it does today. Still have questions?
          <InlineButton
            key="contactSupport"
            style={{color: Colors.red900}}
            onClick={() => contactSupportWithMessage('I need help resolving my payment issue')}
          >
            Contact support.
          </InlineButton>
        </InlineNotification>
      ),
      successMessage && !paymentError && (
        <InlineNotification
          id={`cla-inline-notification-${successId}`}
          iconPath={checkCircle}
          style={{maxWidth: CONTENT_MAX_WIDTH, marginBottom: 20}}
          animate={false}
        >
          {successMessage} Ready to{' '}
          <InlineButton onClick={() => this.context.router.push(routes.MyAccount.ViewDesigns)}>
            create a template?
          </InlineButton>
        </InlineNotification>
      ),
      showSuccessfulRenewBillingAgreementMessage && (
        <InlineNotification
          id="cla-notification-renew-agreement-success"
          iconPath={checkCircle}
          onRequestClose={() => this.setState({showSuccessfulRenewBillingAgreementMessage: false})}
          style={{maxWidth: CONTENT_MAX_WIDTH, marginBottom: 20}}
          animate={false}
        >
          {`Your Paypal updated successfully to ${paypalEmail}`}
        </InlineNotification>
      ),
    ];
  }

  renderPlanDetails() {
    const {
      customPlan,
      paymentError,
      billingPeriod,
      plans,
      userPlanId,
      billingPeriodString,
      switchToAnnualSave,
      eBayAccountsCount,
      activeListingsCount,
      activeListingsLimit,
      eBayAccountsLimit,
    } = this.props;

    const monthlyBilling = billingPeriod === BILLING_PERIOD.MONTH;
    const userPlan = plans[userPlanId];
    const billingCycle = monthlyBilling ? 'annual' : 'monthly';
    return (
      <Paper style={{paddingTop: 30, paddingLeft: 20, maxWidth: CONTENT_MAX_WIDTH, marginBottom: 30}}>
        <div style={styles.h2b}>Plan Details</div>
        <div>
          <ReadOnlyTextField
            id="cla-current-plan"
            floatingLabelText="Current Plan"
            value={userPlan.name.toUpperCase()}
            style={{width: 80, marginRight: 20}}
          />
          <RaisedButton
            id="cla-btn-switch-plan"
            onClick={() =>
              this.context.router.push({
                pathname: routes.MyAccount.Upgrade,
                query: customPlan
                  ? {backTo: PlanAndBillingData.route}
                  : {activeListingsLimit, backTo: PlanAndBillingData.route},
              })
            }
            label="Switch Plan"
          />
        </div>
        <div>
          <ReadOnlyTextField
            id="cla-billing-cycle"
            floatingLabelText="Billing Cycle"
            value={billingPeriodString}
            style={{width: 80, marginRight: 20}}
          />
          <InlineButton
            id={`cla-btn-switch-to-${billingCycle}`}
            disabled={paymentError}
            onClick={() => {
              const {pathname, query} = this.props;
              this.context.router.push({
                pathname,
                query: {
                  ...query,
                  openDialog: CHANGE_PLAN_DIALOG_NAME,
                  changeType: CHANGE_TYPE_BILLING_PERIOD,
                  toBillingPeriod: monthlyBilling ? BILLING_PERIOD.YEAR : BILLING_PERIOD.MONTH,
                },
              });
            }}
            style={{color: monthlyBilling ? Colors.lightGreen700 : Colors.grey700}}
          >
            {monthlyBilling ? (
              <span>
                <strong>Save ${switchToAnnualSave}</strong> by switching to annual billing
              </span>
            ) : (
              'Switch to monthly billing'
            )}
          </InlineButton>
        </div>
        <div style={{...styles.h2, marginTop: 20}}>Plan Includes</div>
        <div>
          <span style={{width: SAME_LINE_BUTTON_SPACING, display: 'inline-block'}}>
            <ReadOnlyTextField
              id="cla-managed-listings"
              floatingLabelText="Managed Listings"
              inputStyle={{
                color:
                  activeListingsLimit && activeListingsCount > activeListingsLimit ? Colors.red900 : Colors.grey700,
              }}
              value={`${activeListingsCount} out of ${activeListingsLimit || 'Unlimited'}`}
            />
          </span>
          <ReadOnlyTextField
            id="cla-ebay-accounts"
            floatingLabelText="eBay Accounts"
            inputStyle={{
              color: eBayAccountsLimit && eBayAccountsCount > eBayAccountsLimit ? Colors.red900 : Colors.grey700,
            }}
            value={`${eBayAccountsCount} out of ${eBayAccountsLimit || 'Unlimited'}`}
          />
        </div>
      </Paper>
    );
  }

  render() {
    return (
      <div style={styles.pageContentContainer}>
        <ChangePlanDialog />
        <EditPaidFeaturesDialog />
        <div style={styles.h1}>Plan & Billing</div>
        <div style={{marginBottom: 20}}>Change your plan anytime.</div>
        {this.renderNotifications()}
        {this.renderPlanDetails()}
        {this.renderAdditionalFeatures()}
        {this.renderPaymentDetails()}
      </div>
    );
  }
}

export default _.assign(PlanAndBilling, PlanAndBillingData);
